
export default {
    connectSocket:function(port,printData){
            let socket = null;
            try {
                socket = new WebSocket('ws://localhost:'+port);
                socket.addEventListener("open",function () {
                    console.log("链接成功。。");
                });
                socket.onopen = function(event)
                {
                    console.log("llws连接!");
                    //设置打印机
                    //var pmCode =  '11112222';
                    //var getPrinterConfigCmd = "{\"requestID\":\""+pmCode+"\",\"verson\":\"1.0\",\"cmd\":\"getPrinterConfig\",\"printer\":\"HP LaserJet Professional M1213nf MFP\"}";
                    //socket.send(getPrinterConfigCmd);

                   /* let request = {
                        cmd: "print",
                        requetID: "12345678901234567890",
                        version: "1.0",
                        task: {
                            taskID: "1",
                            preview: false,
                            printer: "",
                            documents: [
                                {
                                    documentID: "SF1343815116549",
                                    contents: [
                                        //电子面单部分
                                        printData
                                    ]
                                }
                            ]
                        }
                    };*/
                    //socket 发送
                    socket.send(printData);
                };

                socket.onerror =  function(e) {
                    console.log("llws连接错误!");
                };
                // 监听消息
                socket.onmessage = function(event)
                {
                    console.log('Client received a message',event);
                };
                // 监听Socket的关闭
                socket.onclose = function(event)
                {
                    console.log('Client notified socket has closed',event);
                };
            }catch (e) {
                console.log(e.message);
            }finally {
               /* if(null!=socket){
                    socket.close();
                }*/
            }

    },

    doPrint:function (port,printData) {
        this.connectSocket(port,printData);

    },
    
    doPrint2:function (port,printData) {
        return  this.connectSocket2(port,printData);
      },
  
  
      connectSocket2:function(port,printData){
          return new Promise((resolve, reject) => {
              let socket = null;
              try {
                socket = new WebSocket('ws://localhost:' + port);
                socket.addEventListener("open", function() {
                  // console.log("链接成功。。");
                   resolve(); // 连接成功时 resolve
                });
                socket.onopen = function(event) {
                  console.log("llws连接!");
                  socket.send(printData);
                };
          
                socket.onerror = function(e) {
                  // console.log("连接错误!");
                  socket.close(); // 发生错误时关闭连接
                  // console.info('BBBB')
                  reject("PRINTER_NOT_CONNECTED"); // 发生错误时 reject
                };
                // 监听消息
                socket.onmessage = function(event) {
                  // console.log('Client received a message', event);
                };
                // 监听Socket的关闭
                socket.onclose = function(event) {
                  // console.log('Client notified socket has closed', event);
                };
              } catch (e) {
                  // console.info('AAAA')
              //   console.log(e.message);
                reject(e.message); // 发生异常时 reject
              }
            });
  },

}



